import React, { createContext, useContext, useEffect, useState } from "react";
import client from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    const token = localStorage.getItem("fatehfx_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await client.get("/auth/me");
      setUser(data.user);
      setModules(data.modules);
    } catch {
      localStorage.removeItem("fatehfx_token");
      setUser(false);
    } finally { setLoading(false); }
  };

  useEffect(() => { loadMe(); }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("fatehfx_token", data.token);
    await loadMe();
    return data.user;
  };

  const register = async (email, password, name, phone) => {
    const { data } = await client.post("/auth/register", { email, password, name, phone });
    localStorage.setItem("fatehfx_token", data.token);
    await loadMe();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fatehfx_token");
    setUser(false); setModules([]);
    window.location.href = "/login";
  };

  const canAccess = (mod) => modules === "all" || (Array.isArray(modules) && modules.includes(mod));

  return (
    <AuthCtx.Provider value={{ user, modules, loading, login, register, logout, canAccess, reload: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}
